var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"recaptcha-disclaimer"},[_vm._v(" Questo sito è protetto da reCAPTCHA e si applicano le "),_c('a',{attrs:{"href":"https://policies.google.com/privacy","target":"_blank"}},[_vm._v("Privacy Policy")]),_vm._v(" e "),_c('a',{attrs:{"href":"https://policies.google.com/terms","target":"_blank"}},[_vm._v("Termini di servizio")]),_vm._v(" di Google. ")])
}]

export { render, staticRenderFns }